<template>

  <b-modal 
    ref="modal"
    v-model="visible"
    :title="title"
    :size="size"
    @hide="hide"
    hideFooter
  > 
    <slot name="content"/>
  </b-modal>
  
</template>

<script>


export default {
  name: "modal",
  components: {},
  props: {
    title: {
      type: String,
    },
    size: {
      type: String,
      default: "xl"
    }

  },
  data() {
    return {
      visible: false
    };
  },
  methods: {
    
    show(){ 
      this.visible = true;
    },

    hide(){
      this.visible = false;
      this.$emit('onHide');
    }
  }
};
</script>

<style scoped>
</style>
